import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { createGtm } from '@gtm-support/vue-gtm';
import store from './store'
import axios from 'axios'
import i18n from './i18n/index.js'
import { initKeycloak } from '@/keycloakService';

const axiosInstance = axios.create({
    baseURL: window.location.origin == 'https://portal.loxone.com' ? 'https://portal.loxone.com' : 'https://dev-portal.loxone.com',
    crossDomain: true,
    withCredentials: true
});
console.log("VUE_APP_KEYCLOAK_ISSUER", process.env.VUE_APP_KEYCLOAK_ISSUER);
console.log("API URL: ", window.location.origin == 'https://portal.loxone.com' ? 'https://portal.loxone.com' : 'https://dev-portal.loxone.com');
initKeycloak({ onLoad: 'check-sso' }).then(() => {
    const app = createApp(App).use(i18n).use(store).use(router).use(createGtm({
        id: 'GTM-WQP57QJ',
        defer: false,
        compatibility: false,
        nonce: '2726c7f26c',
        enabled: true,
        debug: false,
        loadScript: true,
        vueRouter: router,
        ignoredViews: [],
        trackOnNextTick: false,
    }));
app.config.globalProperties.$axios = axiosInstance
app.mount('#app');
});
